export const onboarding = {
  welcome: {
    title: 'Welcome to First Weeks',
    body: 'Feedings, diapers, weight, and checkups for your first weeks together, from your team at Families First Pediatrics.',
    chooseLanguage: 'Choose your language',
    english: 'English',
    spanish: 'Español',
  },

  role: {
    title: 'Who is using this phone?',
    momTitle: "I'm the mom",
    momHint: 'Set up this phone for you and your baby.',
    partnerTitle: "I'm the partner",
    partnerHint: "I have an invite from mom's phone.",
    inviteDetected: 'We found an invite in your link.',
  },

  baby: {
    title: 'Is baby here yet?',
    expecting: "Not yet, we're expecting",
    here: 'Yes, baby is here!',
    dueDateLabel: 'Your due date',
    dueDateHint: 'We will count down with you and be ready the moment your baby arrives.',
    birthDateLabel: 'When was your baby born?',
    nicknameLabel: 'Baby nickname (optional)',
    nicknameHint: 'A nickname like "Peanut" is perfect. No real name needed, which keeps things private.',
    weightLabel: 'Birth weight (optional)',
    weightHint: 'It is on your hospital paperwork. You can also add it later in Settings.',
    finish: 'Start tracking',
  },

  partner: {
    title: "Connect to mom's phone",
    body: "Enter the invite code from mom's phone. She can create one in Settings, under Partner connection.",
    connectedTitle: 'Connected!',
    connectedBody: 'You are all set. Whatever either of you logs will show up on both phones.',
  },

  privacyNote:
    'Your data stays on this phone. Nothing is sent anywhere unless you connect with your partner, and even then it is encrypted so only your two phones can read it.',
};
